module.exports = __webpack_public_path__ + "img/slika26.b9ae5abc.jpg";